import React from 'react';

const COLORS = {
  success: 'var(--color-primary)', // primary
  info: 'var(--color-accent)',    // accent
  error: 'var(--color-error, #D90429)',   // custom error
};

const ICONS = {
  success: '✔️',
  info: 'ℹ️',
  error: '❌',
};

const Toast = ({ message, type = 'info', onClose }) => {
  return (
    <div className={`fixed top-6 right-6 z-50 glass-card shadow-xl rounded-2xl px-6 py-4 flex items-center gap-4 ${type === 'success' ? 'bg-green-50 text-green-800' : type === 'error' ? 'bg-red-50 text-red-800' : 'bg-blue-50 text-blue-800'}`}>
      <span style={{ fontSize: '1.5rem', marginRight: '0.75rem' }}>{ICONS[type] || ICONS.info}</span>
      <span style={{ flex: 1 }}>{message}</span>
      {onClose && (
        <button
          onClick={onClose}
          style={{
            background: 'transparent',
            border: 'none',
            color: '#fff',
            fontSize: '1.25rem',
            marginLeft: '1rem',
            cursor: 'pointer',
          }}
          aria-label="Close notification"
        >
          ×
        </button>
      )}
    </div>
  );
};

export default Toast; 